import { render } from "./navigation_pins.vue?vue&type=template&id=61b7abc2"
import script from "./navigation_pins.js?vue&type=script&lang=js"
export * from "./navigation_pins.js?vue&type=script&lang=js"

import "./navigation_pins.vue?vue&type=style&index=0&id=61b7abc2&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__